<template>
  <div>
    <div v-if="data.validUntil !== null"
         class="asd-warning"
    >
      <i class="fas fa-trash"></i> Tento projekt byl vyhozen do koše
    </div>
    <div v-if="isTemplate"
         class="asd-notice"
    >
      <i class="fab fa-firstdraft"></i> Toto je šablona projektu
    </div>
    <div class="asd-form-section heading-section">
      <h1>
        <div class="context-menu"
             @click="back"
        >
          <i class="fas fa-arrow-left context-menu-icon"></i>
        </div>
        <ContextMenu
          :items="[
            {
              icon: 'fa-trash',
              label: 'Smazat projekt',
              action: disableProject,
              if: $store.getters.currentUserHasAction('DELETE_PROJECT'),
            },
            {
              icon: 'fa-receipt',
              label: 'Vytvořit šablonu z tohoto projektu',
              action: createTemplate,
              if: !data.isTemplate,
            },
            {
              icon: 'fa-receipt',
              label: 'Projekt z teto sablony',
              action: createFromTemplate,
              if: data.isTemplate,
            },
            {
              icon: 'fa-receipt',
              label: 'Vytvořit kopii z projektu',
              action: createFromTemplate,
              if: !data.isTemplate,
            },
          ]"
        >
          <template #icon>
            <i class="fas fa-bars"></i>
          </template>
        </ContextMenu>
        {{ projectLabel }}
      </h1>
      <div class="asd-badge">
        {{ projectType.name }}
      </div>
    </div>
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-grip-horizontal"></i>
          Vlastnosti
        </h5>
        <div
          v-if="data.validUntil === null && $store.getters.currentUserHasAction('EDIT_PROJECT')"
          class="section-title-controls"
        >
          <span v-if="currentLockInfo.editable === true">
            <ActiveButton v-if="editProperties"
                          class="asd-btn-confirm"
                          :click="save"
            >
              <i class="fas fa-save"></i>
            </ActiveButton>
            <ActiveButton
              v-if="editProperties"
              v-help.mouse="`Neukládat a zrušit editaci`"
              class="asd-btn-cancel"
              :click="cancel"
            >
              <i class="fas fa-times"></i>
            </ActiveButton>
            <button v-if="!editProperties"
                    class="asd-btn-edit"
                    @click="startEditing()"
            >
              <i class="fas fa-pencil-alt"></i>
            </button>
          </span>
          <span v-else
                style="color: Firebrick; padding: 0 5px"
          >
            Právě edituje <strong>{{ currentLockInfo.lockUsername }}</strong>
          </span>
          <span v-if="currentLockInfo.ttl > 0"
                style="color: Firebrick; padding: 0 5px"
          >
            Zámek vyprší za {{ currentLockInfo.ttl }}s</span>
        </div>
      </div>
      <PropertyForm
        v-if="editProperties"
        :key="`PF-${projectId}-${$store.getters.DLI}`"
        v-model="data.propertyValues"
        class="asd-form"
        :meta="{ entityType: projectType }"
        :propertyKeys="projectPropertyKeys"
        @input="onPropertyValuesChange"
      ></PropertyForm>
      <PropertyTable
        v-else
        :key="`PT-${projectId}-${$store.getters.DLI}`"
        v-model="data.propertyValues"
        class="asd-form"
        :propertyKeys="projectPropertyKeys"
      ></PropertyTable>
      <TabbedView style="margin: 10px">
        <template v-for="h in statesHistory">
          <StateHistory :key="`Historie stavu ${h.name}`"
                        :value="h"
          ></StateHistory>
        </template>
        <template>
          <PropertyHistory :key="`Audit historie`"
                           :entity="projectId"
          ></PropertyHistory>
        </template>
        <template>
          <PublicViewList :key="`Public view`"
                          :entity="projectId"
          >
          </PublicViewList>
        </template>
        <template>
          <CheckpointsList :key="`Checkpoints`"
                           :entity="projectId"
          >
          </CheckpointsList>
        </template>
      </TabbedView>
    </div>
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-tasks"></i>
          Úkoly
        </h5>
      </div>
      <div v-if="projectTaskTypes.length > 1"
           class="asd-tabs"
      >
        <div
          :class="{ active: taskTypeFilter === null && taskStatusFilter === '$all' }"
          @click="
            taskTypeFilter = null
            taskStatusFilter = '$all'
          "
        >
          <strong>Všechny</strong>
        </div>
        <div
          v-for="type in projectTaskTypes"
          :key="type.id"
          :class="{ active: taskTypeFilter === type.id }"
          @click="
            taskTypeFilter = type.id
            taskStatusFilter = '$all'
          "
        >
          {{ type.name }}
        </div>
        <div
          :class="{ active: taskStatusFilter === '$deleted' }"
          @click="
            taskTypeFilter = null
            taskStatusFilter = '$deleted'
          "
        >
          <strong> <i class="fas fa-trash"></i> Vymazané </strong>
        </div>
      </div>
      <TaskTable
        :showProjectColumn="false"
        :projectTasks="true"
        :rootFilter="tasksRootFilter"
        :backProjectId="projectId"
        :taskStatus="taskStatusFilter"
        :style="{ overflow: 'scroll' }"
        :addButton="{ name: 'tasksNew', query: { preselectedProjectId: projectId, backProjectId: projectId } }"
      ></TaskTable>
      <TaskTree :projectId="projectId"></TaskTree>
    </div>

    <div v-if="filesSettings.enabled"
         class="asd-form-section"
    >
      <div class="section-title">
        <h5>
          <i class="fas fa-copy"></i>
          Soubory
        </h5>
      </div>
      <FilesBrowser
        v-if="filesBaseFolder !== null"
        :key="filesBaseFolder"
        :baseFolder="filesBaseFolder"
        :basePath="filesSettings.basePath"
      ></FilesBrowser>
      <span v-else
            style="padding: 10px 20px; color: firebrick"
      >
        <i class="fas fa-info-circle"></i>
        Tento projekt nemá definováno či vyplněno
        <strong>{{ filesBasePropName }}</strong>
        tudíž nelze určit které soubory načíst.
      </span>
    </div>

    <div v-if="$store.getters.modules.comments"
         class="asd-form-section"
    >
      <div class="section-title">
        <h5>
          <i class="fas fa-comments"></i>
          Diskuse
        </h5>
      </div>
      <Comments :entityId="project.id"
                :entityType="'project'"
      ></Comments>
    </div>

    <div v-if="$store.getters.modules.attachments"
         class="asd-form-section"
    >
      <div class="section-title">
        <h5>
          <i class="fas fa-paperclip"></i>
          Přílohy
        </h5>
      </div>
      <ProjectAttachments :entityId="project.id">
      </ProjectAttachments>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import labels from 'CORE/utils/labels'
import PropertyTable from 'CORE/components/data-type/property-detail-table'
import PropertyForm from 'CORE/components/form/property-form'
import ProjectDataMixin from 'CORE/mixins/project-data'
import TaskTable from 'CORE/components/task/table'
import TaskTree from 'CORE/components/task/tree'
import FilesBrowser from 'CORE/components/files/browser'
import ProjectAttachments from 'CORE/components/project/attachments'
import Comments from 'CORE/components/comments/comments'
import ActiveButton from 'CORE/components/form/active-button'
import ContextMenu from 'CORE/components/context-menu'
import StateHistory from 'CORE/components/entity-states/history'
import TabbedView from 'CORE/components/tabbed-view/tabbed-view'
import PropertyHistory from 'CORE/components/property/history'
import PublicViewList from 'CORE/components/public-view/list'
import CheckpointsList from 'CORE/components/checkpoints/list.vue'
import EventBus from 'CORE/bus'
import { stompClient } from '@/main'

export default {
    name: 'ProjectDetail',
    components: {
        PropertyForm,
        PropertyTable,
        TaskTable,
        FilesBrowser,
        ProjectAttachments,
        Comments,
        TaskTree,
        ActiveButton,
        ContextMenu,
        StateHistory,
        TabbedView,
        PropertyHistory,
        PublicViewList,
        CheckpointsList,
    },
    mixins: [ProjectDataMixin],
    props: {
        projectId: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            data: {},
            editProperties: false,
            showDeleteProjectModal: false,
            taskTypeFilter: null,
            taskStatusFilter: '$all',
            taskListType: 'table', // table or tree
        }
    },
    computed: {
        statesHistory() {
            const entityStateProperties = _.filter(
                _.get(this.projectType, 'propertyType', {}),
                pt => pt.type === 'ENTITY_STATE'
            )
            return _.map(entityStateProperties, p => {
                const history = _.get(this.data.propertyValues, `${p.key}.value.history`, [])
                return {
                    key: p.key,
                    name: p.name,
                    history,
                }
            })
        },
        currentLockInfo() {
            const currentLock = this.$store.getters.getLock(this.data.id)
            const lockUser = _.get(currentLock, 'user', null)
            const ttl = _.get(currentLock, 'ttl', -1)
            return {
                editable: ttl > 0 ? this.$store.getters.currentUserId === lockUser : true,
                lockUsername: _.get(this.$store.getters.userById(lockUser), 'username'),
                ttl,
            }
        },
        projectLabel() {
            return labels.project(this.data)
        },
        filesSettings() {
            return _.get(this.$store.getters.settings, 'modules.files', {})
        },
        filesBaseFolder() {
            const projectName = _.get(this.projectType, 'name', null)
            const baseFolderProperty = _.get(
                this.project,
                `propertyValues.${this.filesSettings.baseFolderProperty}.value.value`,
                null
            )
            if (baseFolderProperty === null) {
                return projectName + '/'
            }
            const year = '20' + baseFolderProperty.substr(1, 2)
            if (
                _.get(this.project, `propertyValues.${this.filesSettings.baseFolderProperty}.value.value`, null) ===
                null
            ) {
                return null
            }
            if (this.filesSettings.noteProperty !== null) {
                return (
                    projectName +
                    '/' +
                    year +
                    '/' +
                    [
                        baseFolderProperty,
                        _.get(this.project, `propertyValues.${this.filesSettings.noteProperty}.value.value`, null),
                    ].join('_')
                )
            }
            return (
                projectName +
                '/' +
                _.get(this.project, `propertyValues.${this.filesSettings.baseFolderProperty}.value.value`, null)
            )
        },
        filesBasePropName() {
            return _.lowerCase(
                _.get(this.$store.getters.propertyTypeByKey(this.filesSettings.baseFolderProperty), 'name', '')
            )
        },
        projectPropertyKeys() {
            return _.map(_.get(this.projectType, 'propertyType', {}), pt => pt.key)
        },
        projectTaskTypes() {
            return _.map(this.$store.getters.taskTypesByProjectId(this.projectId), typeId => {
                return {
                    id: _.get(this.$store.getters.taskTypeById(typeId), 'id'),
                    name: _.get(this.$store.getters.taskTypeById(typeId), 'name'),
                }
            })
        },
        tasksRootFilter() {
            if (this.taskTypeFilter === null) {
                return null
            } else {
                const taskName = _.get(this.$store.getters.taskTypeById(this.taskTypeFilter), 'name', null)
                return { _type: taskName }
            }
        },
        throttledLockRequire() {
            return _.throttle(() => {
                const data = { user: this.$store.getters.currentUserId, entity: this.data.id, type: 'require' }
                stompClient.publish({
                    destination: '/queue/task.locking',
                    body: JSON.stringify(data),
                    headers: { 'priority': '9', 'content-type': 'application/json' },
                })
            }, 5000)
        },
        isTemplate() {
            return _.get(this.project, 'isTemplate', false)
        },
    },
    watch: {
        currentLockInfo(n, o) {
            if (_.get(n, 'ttl', -1) === 0) {
                this.cancel()
            }
        },
    },
    created() {
        this.data = this.$store.getters.getProjectById(this.projectId)
        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing Project or invalid UUID creation)'
        )
    },
    methods: {
        async disableProject() {
            try {
                await this.$prompt('Opravdu chcete projekt smazat?')
                await this.$store.dispatch('disableProject', this.data.id)
                await this.$store.dispatch('projectsLoad')
                const data = { user: this.$store.getters.currentUserId, entity: this.data.id, type: 'release' }
                stompClient.publish({
                    destination: '/queue/task.locking',
                    body: JSON.stringify(data),
                    headers: { 'priority': '9', 'content-type': 'application/json' },
                })
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.data = this.$store.getters.getProjectById(this.projectId)
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            } finally {
                this.showDeleteProjectModal = false
            }
        },
        async save() {
            try {
                await this.$store.dispatch('updateProject', this.data)
                await this.$store.dispatch('projectsLoad')
                const data = { user: this.$store.getters.currentUserId, entity: this.data.id, type: 'release' }
                stompClient.publish({
                    destination: '/queue/task.locking',
                    body: JSON.stringify(data),
                    headers: { 'priority': '9', 'content-type': 'application/json' },
                })
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.data = this.$store.getters.getProjectById(this.projectId)
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            } finally {
                this.editProperties = false
            }
        },
        async cancel() {
            try {
                await this.$store.dispatch('projectsLoad')
                const data = { user: this.$store.getters.currentUserId, entity: this.data.id, type: 'release' }
                stompClient.publish({
                    destination: '/queue/task.locking',
                    body: JSON.stringify(data),
                    headers: { 'priority': '9', 'content-type': 'application/json' },
                })
                this.data = this.$store.getters.getProjectById(this.projectId)
                this.$emit('done')
            } finally {
                this.editProperties = false
            }
        },
        async createTemplate() {
            try {
                const newId = await this.$store.dispatch('createTemplateFromProject', this.data.id)
                await this.$store.dispatch('projectsLoad')

                this.flash('Vytvořeno', 'success', {
                    timeout: 1500,
                })
                this.$router.push({ name: 'projectsDetail', params: { id: newId } })
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
        async createFromTemplate() {
            this.$router.push({ name: 'createProjectFromTemplate', params: { id: this.data.id } })
        },
        back() {
            this.$emit('back')
        },
        startEditing() {
            const data = { user: this.$store.getters.currentUserId, entity: this.data.id, type: 'require' }
            try {
                stompClient.publish({
                    destination: '/queue/task.locking',
                    body: JSON.stringify(data),
                    headers: { 'priority': '9', 'content-type': 'application/json' },
                })
            } catch (e) {
                console.log(e)
            }

            this.editProperties = true
        },
        onPropertyValuesChange() {
            this.throttledLockRequire()
        },
    },
}
</script>

<style lang="scss" scoped>
.asd-tabs {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid var(--color-primary);
    & > * {
        white-space: nowrap;
        padding: 3px 10px;
        margin-right: 5px;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        border-top: 1px solid;
        border-left: 1px solid;
        border-right: 1px solid;
        background-color: whitesmoke;
        border-color: lightgray;
        cursor: pointer;
    }
    & > *.active {
        border-color: var(--color-input-border);
        background-color: white;
        border-bottom: 1px solid white;
        transform: translateY(1px);
        z-index: 10;
    }
}

.asd-warning {
    color: black;
    background: repeating-linear-gradient(
        135deg,
        rgba(231, 55, 39, 0) 0px,
        rgba(231, 55, 39, 0) 9px,
        rgba(231, 55, 39, 0.7) 10px,
        rgba(231, 55, 39, 0.7) 19px
    );
    font-size: 2rem;
    font-weight: bold;
    padding: 30px;
    text-align: center;
}
.asd-notice {
    color: black;
    background: repeating-linear-gradient(
        135deg,
        rgba(231, 55, 39, 0) 0px,
        rgba(231, 55, 39, 0) 9px,
        rgba(202, 231, 39, 0.7) 10px,
        rgba(202, 231, 39, 0.7) 19px
    );
    font-size: 1rem;
    font-weight: bold;
    padding: 15px;
    text-align: center;
}
</style>
